import React from 'react';
import FactCheckOutlined from '@mui/icons-material/FactCheckOutlined';
import { Chip, Tooltip } from '@mui/material';

import type { PriorAuthorizationCourseViewModel } from '../../../types/priorAuthorizationPrototype';

export interface PriorAuthorizationIndicatorProps {
  course: PriorAuthorizationCourseViewModel;
  isHovered?: boolean;
  onClick?: () => void;
}

export const PriorAuthorizationIndicator: React.FC<PriorAuthorizationIndicatorProps> = ({
  course,
  isHovered = false,
  onClick,
}) => {
  const warning = course.status === 'expired' || course.status === 'exhausted';
  const error = course.status === 'voided' || course.status === 'denied';
  const color = error ? 'error' : warning ? 'warning' : 'primary';

  return (
    <Tooltip arrow placement="bottom" title={`${course.sessionChipLabel}. ${course.billedLabel}`}>
      <Chip
        icon={<FactCheckOutlined />}
        label={course.sessionChipLabel}
        color={color}
        variant={isHovered ? 'filled' : 'outlined'}
        onClick={onClick}
        aria-label={`Course progress: ${course.sessionChipLabel}`}
        sx={{
          height: 32,
          fontWeight: 700,
          bgcolor: isHovered ? undefined : 'background.paper',
          '& .MuiChip-icon': { fontSize: 17 },
        }}
      />
    </Tooltip>
  );
};
